import React from 'react';
import Typography from '@mui/material/Typography';
import FleetWidget from 'models/fleet-management/FleetWidget';

const TextWidget: React.FC<{ widget: FleetWidget; unitWidth: number }> = ({
  widget,
  unitWidth,
}) => {
  return (
    <React.Fragment>
      <Typography variant="h2">{widget.name}</Typography>
      {widget.description != null && <Typography>{widget.description}</Typography>}
    </React.Fragment>
  );
};

export default TextWidget;
